import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { P as PHONE_MASKS, S as SSN_MASK } from './form-input-masks.js';
import { u as updateFormValues, a as updateAddressFormValues, b as updateDateOfBirthFormValues } from './input-handlers.js';
import { d as defineCustomElement$7 } from './custom-popper2.js';
import { d as defineCustomElement$6 } from './form-control-date2.js';
import { d as defineCustomElement$5 } from './form-control-number-masked2.js';
import { d as defineCustomElement$4 } from './form-control-select2.js';
import { d as defineCustomElement$3 } from './form-control-text2.js';
import { d as defineCustomElement$2 } from './form-control-tooltip2.js';
import { d as defineCustomElement$1 } from './identity-address-form.js';

const BusinessOwnerFormInputs = /*@__PURE__*/ proxyCustomElement(class BusinessOwnerFormInputs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputHandler = (name, value) => {
            updateFormValues(this.formController, { [name]: value });
        };
        this.onAddressFormUpdate = (values) => {
            updateAddressFormValues(this.formController, Object.assign(Object.assign({}, this.formController.values.getValue().address), values));
        };
        this.ownerDefaultValue = undefined;
        this.errors = undefined;
        this.formController = undefined;
    }
    render() {
        return (h("div", { key: 'f54192149ae925bcd08b8408816fc41295ef00f4', class: "row gy-3" }, h("div", { key: '1f70faf2c08ebf277b465cb1532276f7525aa47f', class: "col-12 col-md-8" }, h("form-control-text", { key: '7bae6e4b330cbea14e0be40d1b35e804d62f5323', name: "name", label: "Full Name", defaultValue: this.ownerDefaultValue.name, errorText: this.errors.name, inputHandler: this.inputHandler })), h("div", { key: '84cbbbf7cfb0e3c41c37b1194292dcb1f191298e', class: "col-12 col-md-4" }, h("form-control-text", { key: 'c106ea1b06e69d4b4fe3647cd2d0289185fae2e9', name: "title", label: "Title", defaultValue: this.ownerDefaultValue.title, errorText: this.errors.title, inputHandler: this.inputHandler, helpText: "Role at your business, e.g. President, CEO, Treasurer." })), h("div", { key: '8040bd2c6f6d67763578117c9a46e8e82aa18abf', class: "col-12 col-md-6" }, h("form-control-text", { key: '48aea09125f010bc799dc8d0e909f83c33972c3a', name: "email", label: "Email Address", defaultValue: this.ownerDefaultValue.email, errorText: this.errors.email, inputHandler: this.inputHandler })), h("div", { key: '00195bf163c16d8052c97de866bda7ac610cb959', class: "col-12 col-md-6" }, h("form-control-number-masked", { key: 'd02770dcabfc707691ce4262cbca00d30b78a211', name: "phone", label: "Phone Number", defaultValue: this.ownerDefaultValue.phone, errorText: this.errors.phone, inputHandler: this.inputHandler, mask: PHONE_MASKS.US })), h("div", { key: 'c86d87082365b5daebce40e69f98a8813198eefd', class: "col-12 col-md-4" }, h("form-control-date", { key: 'cd2cfaf3c8a6fbb28719cb85ad4b3954ac2ff059', name: "dob_full", label: "Birth Date", defaultValue: this.ownerDefaultValue.dob_full, errorText: this.errors.dob_full, inputHandler: this.inputHandler, onFormControlInput: (e) => updateDateOfBirthFormValues(e, this.formController), helpText: "Must be 18 or older." })), h("div", { key: 'f77e5943b8e04dc20cf9c126f6ad8ee67e27ac12', class: "col-12 col-md-8" }, h("form-control-number-masked", { key: '3828035484d53d7267c7ce1686658eaba2495147', name: "identification_number", label: "SSN", defaultValue: this.ownerDefaultValue.identification_number, errorText: this.errors.identification_number, inputHandler: this.inputHandler, mask: SSN_MASK, helpText: "Enter your full Social Security Number. It is required for Federal OFAC check." })), h("div", { key: '4a67ced4d2a6f2be7f437e59a119ab97ec8c3ffc', class: "col-12" }, h("justifi-identity-address-form", { key: 'e4fbe8bbd642d623f306236b83be7800db619506', errors: this.errors.address, defaultValues: this.ownerDefaultValue.address, handleFormUpdate: this.onAddressFormUpdate }))));
    }
    ;
}, [0, "owner-form-inputs", {
        "ownerDefaultValue": [8, "owner-default-value"],
        "errors": [8],
        "formController": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["owner-form-inputs", "custom-popper", "form-control-date", "form-control-number-masked", "form-control-select", "form-control-text", "form-control-tooltip", "justifi-identity-address-form"];
    components.forEach(tagName => { switch (tagName) {
        case "owner-form-inputs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessOwnerFormInputs);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "form-control-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BusinessOwnerFormInputs as B, defineCustomElement as d };
